import { t } from '../hooks/useT';

const NEBULA_PLAY_URL = 'https://nebula-rush.com/jouer/';
const NEBULA_BANNER_URL = 'https://nebula-rush.com/images/banner.png';

interface NebulaHouseAdProps {
  className?: string;
  compact?: boolean;
}

/** Pub maison PrograGames — en attendant la validation AdSense. */
export function NebulaHouseAd({ className, compact = false }: NebulaHouseAdProps) {
  const rootClass = [className ?? 'house-ad', compact ? 'house-ad--compact' : ''].filter(Boolean).join(' ');

  return (
    <aside className={rootClass} aria-label={t('houseAd.title')}>
      {!compact && <span className="house-ad-kicker">{t('houseAd.kicker')}</span>}
      <a
        className="house-ad-link"
        href={NEBULA_PLAY_URL}
        target="_blank"
        rel="noopener sponsored"
      >
        <img
          className="house-ad-banner"
          src={NEBULA_BANNER_URL}
          alt=""
          width={600}
          height={315}
          loading="lazy"
          decoding="async"
        />
        <span className="house-ad-body">
          {compact && <span className="house-ad-kicker">{t('houseAd.kicker')}</span>}
          <strong className="house-ad-title">{t('houseAd.title')}</strong>
          {!compact && <span className="house-ad-sub">{t('houseAd.subtitle')}</span>}
          <span className="house-ad-cta btn secondary">{t('houseAd.cta')}</span>
        </span>
      </a>
    </aside>
  );
}
